import React from 'react';
import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { standardTitle } from '../../../../form0781/content';
import { confirmEvidenceRemovalPage } from '../../../content/confirmEvidenceRemovalPage';
import { serviceTreatmentRecordsSubmitLater } from '../../../content/serviceTreatmentRecords';
import {
  STR_ANSWER_KEY,
  STR_UPLOAD_ARRAY_PATH,
  serviceTreatmentRecordsOptions,
} from './options';

/**
 * Destructive modal for the entry page: shown when the Veteran changes their
 * answer from Yes to No after uploading files.
 */
export const ServiceTreatmentRecordsRemovalPage = confirmEvidenceRemovalPage({
  shouldConfirm: formData =>
    formData?.[STR_ANSWER_KEY] === false &&
    (formData?.[STR_UPLOAD_ARRAY_PATH] || []).length > 0,
  getItemGroups: formData => [
    {
      intro: <p>We’ll delete these service treatment records you uploaded:</p>,
      items: (formData?.[STR_UPLOAD_ARRAY_PATH] || []).map(
        serviceTreatmentRecordsOptions.text.getItemName,
      ),
    },
  ],
  removeItems: formData => {
    const updated = { ...formData };
    delete updated[STR_UPLOAD_ARRAY_PATH];
    return updated;
  },
  revertSelection: formData => ({ ...formData, [STR_ANSWER_KEY]: true }),
  modalTitle: 'Cancel uploading files?',
  primaryButtonText: 'Cancel and delete',
  secondaryButtonText: 'Keep files',
  alertText: 'We’ve deleted the service treatment records you uploaded.',
});

/** Entry page: "Do you want to upload your service treatment records?" */
export default {
  uiSchema: {
    'ui:title': standardTitle('Your service treatment records'),
    [STR_ANSWER_KEY]: yesNoUI({
      title: 'Do you want to upload your service treatment records?',
      labels: {
        Y: 'Yes, I’ll submit them now',
        N: 'No, I’ll submit them later',
      },
    }),
    'view:serviceTreatmentRecordsSubmitLater': {
      'ui:description': serviceTreatmentRecordsSubmitLater,
      'ui:options': {
        hideIf: formData => formData?.[STR_ANSWER_KEY] !== false,
      },
    },
  },
  schema: {
    type: 'object',
    required: [STR_ANSWER_KEY],
    properties: {
      [STR_ANSWER_KEY]: yesNoSchema,
      'view:serviceTreatmentRecordsSubmitLater': {
        type: 'object',
        properties: {},
      },
    },
  },
};
